import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { 
    url: String,
    delay: { type: Number, default: 300 }
  };

  connect() {
    this.timeout = null;
  }

  debounce(event) {
    clearTimeout(this.timeout);
    
    this.timeout = setTimeout(() => {
      this.search(event.target.value);
    }, this.delayValue);
  }

  search(query) {
    const form = this.element.closest('form');
    if (form) {
      // Update the search input value
      const searchInput = form.querySelector('input[name="search"]');
      if (searchInput) {
        searchInput.value = query;
      }
      
      // Submit the form
      form.submit();
    }
  }
}
